/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function filtersMenuDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            activeFilters: '=',
            activeCategory: '=',
            facets: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: filtersMenu,
        template: require('./filtersMenuView.html')
    };
}

filtersMenu.$inject = [
    'FiltersService',
    'UtilService'

];
function filtersMenu(
    FiltersService,
    UtilService
) {

    this.$onInit = () => {
        const vm = this;

        vm.openedFilterAccordions = [];

        vm.resetFilters = FiltersService.resetFilters;
        vm.removeFilter = removeFilter;
        vm.getFilterInputType = FiltersService.getFilterInputType;
        vm.isCheckboxFilter = FiltersService.isCheckboxFilter;

        vm.isMobile = UtilService.isMobile();

        /**
         * Determines whether or not we should show the active filters on the closed accordions
         *
         * @param filterDetails
         * @returns {boolean|*}
         */
        vm.showActiveOnAccordion = (filterDetails) => {
            return vm.isMobile && vm.activeFilters.filter(filterObj => filterObj.key === filterDetails.code).length > 0
        };

        /**
         * Removes selected filter and re filters results.
         * @param filter
         */
        function removeFilter(filter) {
            FiltersService.resetFilter(filter.key, filter.value);
        }

    };

}

module.exports = filtersMenuDirective;